import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { AppTypes } from '../Types';
import AuthService from '../../services/AuthService';
import RoutingService from '../../services/RoutingService';
import {
  fetchFeedbackTypes,
  submitFeedback,
  fetchFeedbackStatus,
} from '../../services/API/FeedBackService';

const appActions = (state, dispatch) => {
  const _resetError = () => {
    dispatch({ type: AppTypes.RESET_ERROR });
  };
  const _resetInfo = () => {
    dispatch({ type: AppTypes.RESET_INFO });
  };
  const _resetSuccess = () => {
    dispatch({ type: AppTypes.RESET_SUCCESS_MESSAGE });
  };
  const setError = (error, isAutoCancel) => {
    dispatch({ type: AppTypes.SET_ERROR, payload: { error } });
    if (isAutoCancel) {
      setTimeout(() => {
        _resetError();
      }, 3000);
    }
  };
  const setInfo = (info, isAutoCancel) => {
    dispatch({ type: AppTypes.SET_INFO, payload: { info } });
    if (isAutoCancel) {
      setTimeout(() => {
        _resetInfo();
      }, 3000);
    }
  };
  const setSuccess = (success, isAutoCancel) => {
    dispatch({ type: AppTypes.SET_SUCCESS_MESSAGE, payload: { success } });
    if (isAutoCancel) {
      setTimeout(() => {
        _resetSuccess();
      }, 3000);
    }
  };

  const initializeApp = getOnBoardingStatus => {
    const token = AuthService.getAuthToken();

    if (isEmpty(token)) {
      /**
       * When token unavailable
       */
      RoutingService.gotoOnboardLanguageSelection();
    } else {
      /**
       * TODO if invalid token Login
       */

      getOnBoardingStatus();
    }
  };

  const setMuted = () => {
    dispatch({
      type: AppTypes.TOGGLE_MUTE,
    });
  };

  const disableVideo = () => {
    dispatch({
      type: AppTypes.DISABLE_VIDEO,
    });
  };

  /**
   *
   * App Rating and Feedback
   */

  function setSelectedRating(rating) {
    dispatch({ type: AppTypes.SET_SELECTED_RATING, payload: rating });
  }

  function getFeedbackTags() {
    dispatch({
      type: AppTypes.IS_API_PROGRESS,
      payload: true,
    });
    fetchFeedbackTypes()
      .then(tags => {
        dispatch({
          type: AppTypes.FEEDBACK_TYPES,
          payload: get(tags, 'types', {}),
        });
      })
      .catch(error => {
        console.log('Feedback Fetch -> error', error);
      })
      .finally(() => {
        dispatch({
          type: AppTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  }

  function getFeedbackStatus() {
    dispatch({
      type: AppTypes.IS_API_PROGRESS,
      payload: true,
    });
    fetchFeedbackStatus()
      .then(status => {
        dispatch({ type: AppTypes.SET_FEEDBACK_STATUS, payload: status });
      })
      .catch(error => {
        console.log('Feedback Status Fetch -> error', error);
      })
      .finally(() => {
        dispatch({
          type: AppTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  }

  function submitAppFeedback(payload, cb) {
    const { types, comment } = payload;
    const { appRating } = state;
    const userId = AuthService.getUserID();

    if (appRating === 0) return;

    dispatch({
      type: AppTypes.IS_API_PROGRESS,
      payload: true,
    });
    submitFeedback({ userId, rating: appRating, types, comment })
      .then(() => {
        dispatch({
          type: AppTypes.RATING_SUCCESS,
          payload: false,
        });
        cb && cb();
      })
      .catch(error => {
        console.log('Submit App Feedback -> error', error);
      })
      .finally(() => {
        dispatch({
          type: AppTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  }

  function setLandingPageLanguage(locale) {
    dispatch({ type: AppTypes.SET_LANDING_PAGE_LANGUAGE, payload: locale });
  }

  return {
    setError,
    setInfo,
    setSuccess,
    initializeApp,
    setMuted,
    disableVideo,
    setSelectedRating,
    getFeedbackTags,
    getFeedbackStatus,
    submitAppFeedback,
    setLandingPageLanguage,
  };
};
export default appActions;
